import Cookies from 'js-cookie';
import Swiper from 'swiper';
import { $Elements, BrowserEvents, TransitionDurations } from './constants';

;(function($) {

	$Elements.document.on(BrowserEvents.page.enter, () => {

		// ---------- Disclaimer ----------

		$('#disclaimer').on('closed.bs.alert', function() {

			Cookies.set('tc-disclaimer', true, {
				expires: 365,
				path: '/',
			});

			$Elements.body.removeClass('disclaimer-open');

			$(this).remove();
		});

		// ---------- Cookies ----------

		$('#cookies-law').on('closed.bs.alert', function() {

			Cookies.set('tc-cookies', true, {
				expires: 365,
				path: '/',
			});

			$(this).remove();
		});

		// ---------- Carousels ----------

		$('.content-section .masonry').each(function() {
			const self = $(this);

			self.isotope({
				masonry: {
					percentPosition: true
				},
				itemSelector: ".single-column"
			})
		});

		$('.content-section .carousel').each(function() {

			if(!this.swiper) {

				const swiper = new Swiper(this, {
					speed: TransitionDurations.default,
					loop: true,
					observer: true,
					pagination: {
						el: this.querySelector('.swiper-pagination'),
					},
					navigation: {
						nextEl: this.querySelector('.next'),
						prevEl: this.querySelector('.prev'),
					},
				});
			}
		});

		$('.content-section .slideshow').each(function() {

			if(!this.swiper) {

				const swiper = new Swiper(this, {
					speed: TransitionDurations.default,
					loop: true,
					effect: 'fade',
					observer: true,
					autoplay: true,
					pagination: {
						el: this.querySelector('.swiper-pagination'),
					},
					navigation: {
						nextEl: this.querySelector('.next'),
						prevEl: this.querySelector('.prev'),
					},
				});
			}
		});

	});

}(jQuery));
